/*
 * Article (SEO/GEO): auto-generated table of contents.
 * Scans the article's H2/H3 headings, gives them anchor ids
 * and builds the list in [data-toc]. The box is only shown when
 * there are enough headings (data-toc-min-headings).
 */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      // Ligatures and letters that NFD does not decompose.
      .replace(/ß/g, 'ss')
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'o')
      .replace(/đ|ð/g, 'd')
      .replace(/þ/g, 'th')
      .replace(/ł/g, 'l')
      // Strip the remaining diacritics (ä ö ü á é í ó ú ñ ç ...).
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/[\s-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .substring(0, 80);
  }

  function init() {
    var toc = document.querySelector('[data-toc]');
    var content = document.querySelector('[data-article-content]');
    if (!toc || !content) return;

    var list = toc.querySelector('[data-toc-list]');
    var minHeadings = parseInt(toc.getAttribute('data-toc-min-headings'), 10) || 3;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));

    headings = headings.filter(function (h) {
      return !h.hasAttribute('data-toc-exclude') && h.textContent.trim().length > 0;
    });

    if (headings.length < minHeadings) return;

    var usedIds = {};
    var currentSubList = null;

    headings.forEach(function (heading) {
      if (!heading.id) {
        var id = slugify(heading.textContent) || 'section';
        while (usedIds[id] || document.getElementById(id)) {
          id += '-2';
        }
        usedIds[id] = true;
        heading.id = id;
      }

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);

      if (heading.tagName === 'H3') {
        if (!currentSubList) {
          currentSubList = document.createElement('ul');
          currentSubList.className = 'article-geo__toc-sub';
          var lastLi = list.lastElementChild;
          if (lastLi) {
            lastLi.appendChild(currentSubList);
          } else {
            list.appendChild(currentSubList);
          }
        }
        currentSubList.appendChild(li);
      } else {
        currentSubList = null;
        list.appendChild(li);
      }
    });

    toc.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
